<template>
    <div>
        <div
            class="
                columns
                is-desktop
                h-100
                has-background-greyBG
                is-flex
                is-justify-content-center
                is-align-items-center
                is-vcentered
                is-centered
                has-text-centered
            "
        >
            <div
                v-if="isLogged && isSupervisor"
                class="column is-3"
            >
                <article
                    class="box-inicio is-pointer"
                    @click="goTo('create-room')"
                >
                    <div class="article-top-left has-background-secondary p-4">
                        <img
                            src="@/assets/images/user-videoNew2.png"
                            alt="crear sala"
                            width="80"
                        />
                    </div>
                    <div class="article-content-left p-5">
                        <p class="title is-4 has-text-secondary">
                            {{ $t("home.create-room-subtitle") }}
                        </p>
                        <p class="subtitle is-6 mt-6 has-text-greyText">
                            {{ $t("home.create-room-indications") }}
                        </p>
                    </div>
                </article>
            </div>
            <div
                class="column is-3"
                v-if="isSupervisor"
            >
                <article
                    class="box-inicio is-pointer"
                    @click="goTo('supervisor-panel')"
                >
                    <div class="article-top-right has-background-primary p-4">
                        <img
                            src="@/assets/images/user-video.png"
                            alt="crear sala"
                            width="80"
                        />
                    </div>
                    <div class="article-content-right p-5">
                        <p class="title is-4 has-text-primary">
                            Panel de Supervisor
                        </p>
                        <p class="subtitle is-6 mt-6 has-text-greyText">
                            Panel de administración para los usuarios
                            supervisores
                        </p>
                    </div>
                </article>
            </div>
            <div
                v-if="isLogged && isSupervisorSurveys"
                class="column is-3"
            >
                <article
                    class="box-inicio is-pointer"
                    @click="goTo('survey-online-rooms')"
                >
                    <div class="article-top-left has-background-secondary p-4">
                        <img
                            src="@/assets/images/user-videoNew2.png"
                            alt="crear sala"
                            width="80"
                        />
                    </div>
                    <div class="article-content-left p-5">
                        <p class="title is-4 has-text-secondary">
                            {{ $t("home.online-survey-users-room") }}
                        </p>
                        <p class="subtitle is-6 mt-6 has-text-greyText">
                            {{ $t("home.create-rooms-online") }}
                        </p>
                    </div>
                </article>
            </div>
            <div
                v-if="isLogged && isAuditor"
                class="column is-3"
            >
                <article
                    class="box-inicio is-pointer"
                    @click="goTo('rooms')"
                >
                    <div class="article-top-right has-background-primary p-4">
                        <img
                            src="@/assets/images/user-video.png"
                            alt="Auditoria de videos"
                            width="80"
                        />
                    </div>
                    <div class="article-content-left p-5">
                        <p class="title is-4 has-text-primary">
                            Panel de Auditor
                        </p>
                        <p class="subtitle is-6 mt-6 has-text-greyText">
                            Panel de videos para los auditores
                        </p>
                    </div>
                </article>
            </div>
        </div>
        <div
            class="
                columns
                is-desktop
                h-100
                has-background-greyBG
                is-flex
                is-justify-content-center
                is-align-items-center
                is-vcentered
                is-centered
                has-text-centered
            "
        >
            <div
                v-if="isLogged && isOperador"
                class="column is-3"
            >
                <article
                    class="box-inicio is-pointer"
                    @click="goTo('online-operator')"
                >
                    <div class="article-top-left has-background-secondary p-4">
                        <img
                            src="@/assets/images/user-video.png"
                            alt="Operador"
                            width="80"
                        />
                    </div>
                    <div class="article-content-left p-5">
                        <p class="title is-4 has-text-secondary">
                            {{ $t("home.online-operators-room") }}
                        </p>
                        <p class="subtitle is-6 mt-6 has-text-greyText">
                            {{ $t("home.online-operators-subtitle") }}
                        </p>
                    </div>
                </article>
            </div>
            <div
                v-if="!isLogged"
                class="column is-4 mt-4"
            >
                <article
                    class="box-inicio"
                >
                    <div class="article-top-left has-background-secondary p-4">
                        <img
                            src="@/assets/images/user-video.png"
                            alt="Inicio"
                            width="80"
                        />
                    </div>
                    <div class="article-content-left p-5">
                        <p class="title is-4 has-text-secondary">
                            Centro de Atención de Usuario del Tribunal Electoral
                        </p>
                        <p class="subtitle is-6 mt-6 has-text-greyText">
                            Bienvenid@
                        </p>
                    </div>
                </article>
            </div>
        </div>
        <JoinRoomModal :display="joinRoom" />
        <CreateRoomModal :display="createRoom" />
    </div>
</template>

<script>
import JoinRoomModal from "@/components/join-room/JoinRoomModal.vue";
import CreateRoomModal from "@/components/create-room/CreateRoomModal.vue";
import { mapGetters } from "vuex";

export default {
    name: "welcome",
    components: {
        JoinRoomModal,
        CreateRoomModal,
    },
    props: {
        joinRoom: {
            type: Boolean,
            default: false,
        },
        createRoom: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters("oidcStore", ["oidcIsAuthenticated", "oidcUser"]),
        isLogged() {
            return this.oidcIsAuthenticated;
        },
        roles() {
            return this.oidcUser?.role ?? [];
        },
        isSupervisor() {
            let roles = this.oidcUser?.role;
            return roles && roles.indexOf("Supervisor") > -1;
        },
        isSupervisorSurveys() {
            let roles = this.oidcUser?.role;
            return roles && roles.indexOf("SupervisorSurveys") > -1;
        },
        isOperador() {
            let roles = this.oidcUser?.role;
            return roles && roles.indexOf("Operador") > -1;
        },
        isAuditor() {
            let roles = this.oidcUser?.role;
            return roles && roles.indexOf("Auditor") > -1;
        },
    },
    mounted() {
        let redirectSurveyOnline = window.localStorage.getItem(
            "redirectSurveyOnline"
        );
        if (redirectSurveyOnline) {
            window.localStorage.removeItem("redirectSurveyOnline");
            window.location.href = redirectSurveyOnline;
        }
    },
    methods: {
        goTo(name) {
            this.$router.push({ name: name });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/_variables";
@import "src/assets/scss/_colores";

.box-center-vertical {
    flex: 1;
    min-height: calc(100vh - 3.25rem);
}

.box-inicio {
    margin: 0 25px;
    box-shadow: $box-shadow-h;
}

.article-content-left {
    border: 1px solid $secondary;
}

.article-content-right {
    border: 1px solid $primary;
}

@media only screen and (max-width: 768px) {
    .box-inicio {
        margin: 0 95px;
    }
}

@media only screen and (max-width: 600px) {
    .box-inicio {
        margin: 0 20px;
        box-shadow: $box-shadow-h;
    }

    .box-center-vertical {
        margin-top: 5%;
    }
}
</style>
